import type { Env } from './enums';

/**
 * Amplitude device_id. 프로젝트 하나에 dev·prod 를 함께 보내므로(env 프로퍼티로 구분) dev 만 접두를 붙인다.
 * 같은 기기의 dev·prod 앱은 identifierForVendor·ANDROID_ID 가 같아 그대로 쓰면 가입 전 이벤트가 한 사람으로 합쳐진다.
 * 서버 /auth deviceId·X-Device-Id 헤더는 접두 없는 원래 값이고, 클라·서버가 Amplitude 로 보낼 때만 이 함수를 거친다.
 */
export const amplitudeDeviceId = (stage: Env, deviceId: string): string => (stage === 'prod' ? deviceId : `dev:${deviceId}`);
